import { createTheme } from '@mui/material/styles';
import { playComponents } from './components';
import { darkPaletteOptions, lightPaletteOptions } from './palette';
import { typographyOptions } from './typography';
const base = createTheme();
const withTypography = createTheme(base, {
    typography: typographyOptions(base)
});
export const lightTheme = createTheme(withTypography, {
    palette: lightPaletteOptions(withTypography),
});
const darkBase = createTheme(withTypography, {
    palette: darkPaletteOptions(withTypography),
});
export const darkTheme = createTheme(darkBase, {
    components: playComponents(darkBase),
});
//# sourceMappingURL=theme.js.map